import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditVenueForm = (strings: any, isOperaIntegration: boolean = false): FormModel[] => {
  return [
    {
      label: strings.venue_text_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.venue_text_description,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'description',
      validators: [{ check: Validators.validateString, max: 2000 }],
      responsive: { xs: 12, sm: 6, md: 8, lg: 9 },
      required: false,
    },
    {
      label: strings.venue_text_availability,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_text_availability,
      field: 'available',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      isMulti: false,
    },
    {
      label: strings.venue_title_venueType,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_title_venueType,
      field: 'venueTypeId',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      isMulti: false,
    },
    {
      label: strings.venue_text_excessGuestPercent,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'excessGuestPercentage',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      endAdornment: '%',
    },
    {
      label: strings.venue_text_excessGuestRatePercent,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'excessGuestRatePercentage',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.venue_text_sort_order,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'sortOrder',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 999999 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: strings.venue_text_Booking_window,
      value: '',
      type: 'text',
      typeValue: 'number',
      placeholder: '',
      field: 'bookingWindow',
      validators: [{ check: Validators.validateInt, max: 300 }],
      required: false,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.venue_text_hsnCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'hsnCode',
      validators: isOperaIntegration
        ? [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 15 }]
        : [{ check: Validators.validateString, max: 15 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: isOperaIntegration,
    },
    {
      label: strings.venue_text_parentVenueId,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_text_parentVenueId,
      field: 'parentVenueId',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
      isMulti: false,
    },
    {
      label: 'Tax Mappings',
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },

    {
      label: strings.venue_text_taxGroupOnGuestCharge,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_text_taxGroupOnGuestCharge,
      field: 'taxGroupOnGuestCharge',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 4, lg: 4 },
      required: true,
      isMulti: false,
      isClearable: false,
    },
    {
      label: strings.venue_text_taxGroupOnHallRental,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_text_taxGroupOnHallRental,
      field: 'taxGroupOnHallRental',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 4, lg: 4 },
      required: true,
      isMulti: false,
      isClearable: false,
    },
    {
      label: strings.venue_text_taxGroupOnServiceCharge,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.venue_text_taxGroupOnServiceCharge,
      field: 'taxGroupOnServiceCharge',
      validators: [],
      responsive: { xs: 12, md: 4, lg: 4 },
      required: false,
      isMulti: false,
      isClearable: true,
    },
    {
      label: 'Dimensions',
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.venue_text_length,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'length',
      validators: [{ check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: strings.venue_text_height,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'height',
      validators: [{ check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: strings.venue_text_width,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'width',
      validators: [{ check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: `${strings.venue_text_area} (${strings.venue_text_unit})`,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'area',
      validators: [{ check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
  ];
};
